// assets/partners-hero-search.js
(function () {
  function q(root, sel){ return root.querySelector(sel); }
  function qa(root, sel){ return Array.from(root.querySelectorAll(sel)); }

  document.addEventListener("DOMContentLoaded", () => {
    const root = document.querySelector("[data-hc-partners-root]");
    if (!root) return;

    const dataEl = q(root, "[data-hc-search-data]");
    const input = q(root, "[data-hc-search-input]");
    const dd = q(root, "[data-hc-search-dd]");
    const ddInner = q(root, "[data-hc-search-dd-inner]");
    if (!dataEl || !input || !dd || !ddInner) return;

    let data = { categories: [], apps: [] };
    try { data = JSON.parse(dataEl.textContent || "{}"); } catch(e){}

    const mark = (text, term) => {
      if (!term) return text;
      const i = text.toLowerCase().indexOf(term.toLowerCase());
      if (i < 0) return text;
      const a = text.slice(0, i);
      const b = text.slice(i, i + term.length);
      const c = text.slice(i + term.length);
      return `${a}<span class="hc-dd-mark">${b}</span>${c}`;
    };

    const renderItem = (item, term, typeLabel) => {
      const icon = item.icon
        ? `<div class="hc-dd-item__icon"><img src="${item.icon}" alt=""></div>`
        : `<div class="hc-dd-item__icon"><div class="hc-dd-item__ph"></div></div>`;

      const meta = item.meta ? `<div class="hc-dd-item__meta">${item.meta}</div>` : `<div class="hc-dd-item__meta">${typeLabel}</div>`;
      const desc = item.desc ? `<div class="hc-dd-item__desc">${mark(item.desc, term)}</div>` : "";

      return `
        <a class="hc-dd-item" href="${item.url}">
          ${icon}
          <div class="hc-dd-item__body">
            <div class="hc-dd-item__title">${mark(item.title, term)}</div>
            ${meta}
            ${desc}
          </div>
        </a>
      `;
    };

    const close = () => {
      dd.classList.remove("is-open");
      ddInner.innerHTML = "";
    };

    const open = () => dd.classList.add("is-open");

    const build = (term) => {
      const t = (term || "").trim();
      if (t.length < 2) { close(); return; }

      const cats = (data.categories || []).filter(x =>
        (x.title || "").toLowerCase().includes(t.toLowerCase())
      ).slice(0, 5);

      const apps = (data.apps || []).filter(x => {
        const hay = `${x.title||""} ${x.desc||""} ${x.keywords||""} ${x.meta||""}`.toLowerCase();
        return hay.includes(t.toLowerCase());
      }).slice(0, 6);

      if (!cats.length && !apps.length) {
        ddInner.innerHTML = `<div class="hc-dd-empty">No results for “${t}”.</div>`;
        open();
        return;
      }

      let html = "";
      if (cats.length) {
        html += `<div class="hc-dd-group">
          <div class="hc-dd-group__title">Categories</div>
          ${cats.map(x => renderItem({ ...x, desc: "" }, t, "Category")).join("")}
        </div>`;
      }
      if (apps.length) {
        html += `<div class="hc-dd-group">
          <div class="hc-dd-group__title">Apps</div>
          ${apps.map(x => renderItem(x, t, "App")).join("")}
        </div>`;
      }

      ddInner.innerHTML = html;
      open();
    };

    input.addEventListener("input", (e) => build(e.target.value));
    input.addEventListener("focus", (e) => build(e.target.value));

    document.addEventListener("click", (e) => {
      if (!root.contains(e.target)) close();
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") close();
    });
  });
})();